var map = {
	"./Balushahi.jpg": 7862,
	"./Bhakarwadi.jpg": 1473,
	"./Bun.jpg": 6960,
	"./Burger Bun.jpg": 8851,
	"./CREAM ROLL.jpg": 7824,
	"./Chatini Toast.jpg": 2666,
	"./Chiwda.jpg": 8063,
	"./Chocolate Burfi.jpg": 3165,
	"./Chocolate Cookies.jpg": 3304,
	"./Chocolate Truffle Cake.jpg": 2983,
	"./Chocolate cake.jpg": 6629,
	"./Coconut Cookies.jpg": 8191,
	"./Cream Bun.jpg": 6118,
	"./Dal Seva.jpg": 9657,
	"./Dharwad Pedha.jpg": 7586,
	"./Dilkush.jpg": 2725,
	"./GHEE MYSORE PAK.jpg": 385,
	"./Ganthiya.jpg": 6718,
	"./Honey Cake.jpg": 2652,
	"./Jalebi.jpg": 5534,
	"./Jam Roll Cake.jpg": 7984,
	"./Kachori.jpg": 7436,
	"./Kaju Cookies.jpg": 381,
	"./Khara Bondhi.jpg": 5546,
	"./Makai Chiwada.jpg": 167,
	"./Malpuri.jpg": 6131,
	"./Maska Bun.jpg": 6809,
	"./Milk Burfi.jpg": 1978,
	"./Mini Samosa.jpg": 1520,
	"./Mixture.jpg": 2911,
	"./Mixture1.jpg": 2962,
	"./Motichoor Ladoo.jpg": 1850,
	"./Mysore Pak.jpg": 1984,
	"./PAV.jpg": 6394,
	"./Papadi.jpg": 58,
	"./Pineapple Cake.jpg": 6421,
	"./Pizza Base.jpg": 9274,
	"./Plain Samosa.jpg": 9055,
	"./Plain Toast.jpg": 3694,
	"./Plum Cake.jpg": 6149,
	"./Rasgulla.jpg": 6464,
	"./Rasmalai.jpg": 1137,
	"./Red Velvet Cake.jpg": 176,
	"./Roll Cake.jpg": 5048,
	"./Samosa.jpg": 3035,
	"./Sandwitch Bread.jpg": 9434,
	"./Sev Medium.jpg": 8676,
	"./Sev Small.jpg": 92,
	"./Sev big.jpg": 4959,
	"./Slice Cake1.jpg": 9316,
	"./Sobudana Chiwda.jpg": 8454,
	"./Strawberry Cake.jpg": 4650,
	"./Sweet boondi.jpg": 2852,
	"./Tutti Frutti Cookies.jpg": 6750,
	"./Twistedf khari.jpg": 9898,
	"./VEF PUFF.jpg": 6203,
	"./Vanilla Cake.jpg": 4236,
	"./Vegetable Samosa.jpg": 3636,
	"./cake.1.jpg": 4048,
	"./cake.2.jpg": 8383,
	"./cake.3.jpg": 5714,
	"./cake.4.jpg": 4945,
	"./dilpasand.jpg": 4571,
	"./dryfruits laddu.jpg": 8243,
	"./jaanmun.jpg": 5361,
	"./kaju katli.jpg": 9009,
	"./kalakhand.jpg": 6208,
	"./logo1.jpg": 3741,
	"./long khari.jpg": 4944,
	"./milk bread.jpg": 6295,
	"./project1.jpg": 6943,
	"./project2.jpg": 9568,
	"./project3.jpg": 4461,
	"./ragi cookies.jpg": 6329,
	"./sweet bread.jpg": 1549,
	"./vagan.jpeg": 7481,
	"./wheat bread.jpg": 8284
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2180;